module.exports = __webpack_public_path__ + "img/uk-retail-1.0615f016.png";